export default __webpack_public_path__ + "static/media/next-level-btn.fdd4fe44.gif";